export default __webpack_public_path__ + "static/media/surrealism.e4b8459e.png";